import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {DATASET_DIMENSIONS_STATE_NAME, DataSetDimensionsState} from './dataSetDimensions';
import {Serializers} from '../../interfaces/serializer';
import {DataSetDimension} from '../../interfaces/dimensions';
import {DimensionComponentObjects} from '../../classes/dimension-component-object';

export const selectDataSetDimensionsState: MemoizedSelector<object, DataSetDimensionsState> = createFeatureSelector(DATASET_DIMENSIONS_STATE_NAME);

export const selectDataSetDimensions: MemoizedSelector<object, Serializers<DataSetDimension>> = createSelector(
  selectDataSetDimensionsState,
  (state: DataSetDimensionsState): Serializers<DataSetDimension> => state.serialized.all
);

export const selectDataSetDimensionsNormalized: MemoizedSelector<object, Serializers<DataSetDimension>> = createSelector(
  selectDataSetDimensionsState,
  (state: DataSetDimensionsState): Serializers<DataSetDimension> => state.serialized.normalized
);

export const selectDataSetDimensionsSource: MemoizedSelector<object, Serializers<DataSetDimension>> = createSelector(
  selectDataSetDimensionsState,
  (state: DataSetDimensionsState): Serializers<DataSetDimension> => state.serialized.source
);

export const selectDataSetDimensionComponentObjects: MemoizedSelector<object, DimensionComponentObjects> = createSelector(
  selectDataSetDimensionsState,
  (state: DataSetDimensionsState): DimensionComponentObjects => state.componentObjects.all
);

export const selectDataSetDimensionNormalizedComponentObjects: MemoizedSelector<object, DimensionComponentObjects> = createSelector(
  selectDataSetDimensionsState,
  (state: DataSetDimensionsState): DimensionComponentObjects => state.componentObjects.normalized
);

export const selectDataSetDimensionSourceComponentObjects: MemoizedSelector<object, DimensionComponentObjects> = createSelector(
  selectDataSetDimensionsState,
  (state: DataSetDimensionsState): DimensionComponentObjects => state.componentObjects.source
);

export const selectDataSetDimensionsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectDataSetDimensionsState,
  (state: DataSetDimensionsState): boolean => state.loaded
);

export const selectDataSetDimensionsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectDataSetDimensionsState,
  (state: DataSetDimensionsState): boolean => state.loading
);

